import {EntityKey} from './entity-key';
import {SingleEntityLine} from './single-entity-line';

export class EntityLine {

  entityKey!: EntityKey;
  lineId!: string;
  active!: boolean;
  applicableForDiscount!: boolean;
  approvalDate: any;
  approvalStatusCode!: string;
  associatedEntityId!: string;
  associatedEntityRevision!: number;
  associatedLineId!: string;
  cancelDate: any;
  cancelReasonCode!: string;
  configurationComplete!: boolean;
  configurationId!: string;
  singleEntityLines!: SingleEntityLine[];
  createTimestamp: any;
  createUser!: string;
  customerItemId!: string;
  customerPurchaseOrderLineNumber!: string;
  dateUserField1: any;
  dateUserField2: any;
  dateUserField3: any;
  dateUserField4: any;
  dateUserField5: any;
  deliveryTermsCode!: string;
  demandCategoryCode!: string;
  description!: string;
  dropShip!: boolean;
  entityLeadTime: any;
  expediteCode!: string;
  externalNotes!: string;
  finalExtendedPrice!: number;
  finalUnitPrice!: number;
  frozen!: boolean;
  holdReasonCode!: string;
  initialUnitPrice!: number;
  internalNotes!: string;
  itemNumber!: string;
  itemRevision!: string;
  kit!: boolean;
  largeTextUserField1!: string;
  largeTextUserField2!: string;
  largeTextUserField3!: string;
  largeTextUserField4!: string;
  largeTextUserField5!: string;
  lineConfigured!: boolean;
  numericUserField1!: number;
  numericUserField2!: number;
  numericUserField3!: number;
  numericUserField4!: number;
  numericUserField5!: number;
  passedToErp!: boolean;
  passToErp!: boolean;
  priceBasisDate: any;
  priceListId!: string;
  priorityCode!: string;
  product: any;
  quantity!: number;
  quantityCancelled!: number;
  quantityExtended!: number;
  requestedDeliveryDate: any;
  requestedShipDate: any;
  securityClassCode!: string;
  sentForApprovalDate: any;
  smallTextUserField1!: string;
  smallTextUserField2!: string;
  smallTextUserField3!: string;
  smallTextUserField4!: string;
  smallTextUserField5!: string;
  statusCode!: string;
  transportationTermsCode!: string;
  typeCode!: string;
  updateTimestamp: any;
  updateUser!: string;
  validZeroPrice!: boolean;
  priceBreaks!: any[];

}
